"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumerableFactory = void 0;
const List_1 = require("../collections/List");
const ArrayEnumerable_1 = require("../enumerables/ArrayEnumerable");
const BasicEnumerable_1 = require("../enumerables/BasicEnumerable");
const Grouping_1 = require("../enumerables/Grouping");
const OrderedEnumerable_1 = require("../enumerables/OrderedEnumerable");
class EnumerableFactory {
    createBasicEnumerable(generator) {
        return new BasicEnumerable_1.BasicEnumerable(this, generator);
    }
    createOrderedEnumerable(generator) {
        return new OrderedEnumerable_1.OrderedEnumerable(this, generator);
    }
    createGroupedEnumerable(key, generator) {
        return new Grouping_1.Grouping(this, key, generator);
    }
    createArrayEnumerable(generator, srcArr) {
        return new ArrayEnumerable_1.ArrayEnumerable(this, generator, srcArr);
    }
    createList(generator) {
        return new List_1.List(generator());
    }
}
exports.EnumerableFactory = EnumerableFactory;
//# sourceMappingURL=EnumerableFactory.js.map